import React from 'react'
import PropTypes from 'prop-types'

import style from './style.module.scss'

FieldGroup.propTypes = {
  children: PropTypes.node,
}

function FieldGroup(props) {
  const { children } = props

  return <div className={style.wrapper}>{children}</div>
}

export default React.memo(FieldGroup)
